import React from "react";

export default function Versao1016() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-black mt-8">
        Melhorias Recentes – Versão 1.0.16
      </h2>

      <ul className="space-y-4 text-black text-base leading-relaxed">
        <li>
          <strong>👥 Nova tela de Clientes:</strong>
          <p className="ml-4">
            Agora o sistema possui uma tela completa para gerenciamento de
            clientes — com funções para criar, editar, listar e excluir de forma
            simples e moderna. ✅
          </p>
        </li>

        <li>
          <strong>📝 Bloco de Anotações:</strong>
          <p className="ml-4">
            Dentro do cadastro de clientes foi adicionado um novo campo chamado
            <strong> Bloco de Anotações</strong>, permitindo registrar
            observações e detalhes importantes diretamente no perfil do cliente.
            🗒️
          </p>
        </li>
      </ul>
    </div>
  );
}